import { FilterOptionLicense, FilterOptionDate } from 'src/models/FilterMetric';

type FilterMetricData = {
  filterDateSelected: FilterOptionDate;
  filterLicenseSelected: FilterOptionLicense;
  filterSubagentSelected: FilterOptionLicense;
  isCheckedCurrentUserFilter: boolean;
};

const buildQueryFilterQuotationsMeasurements = (
  {
    filterDateSelected,
    filterLicenseSelected,
    isCheckedCurrentUserFilter,
    filterSubagentSelected,
  }: FilterMetricData,
  currentUser: string,
  loggedUserRole: string,
): string => {
  let query = '?';

  // Filter date to query string
  query += `filter[where][createdat][gte]=${filterDateSelected.startDate}&filter[where][createdat][lte]=${filterDateSelected.endDate}`;

  // add query filter with the license only if the user select a license ( license queryKey are empty or default)
  if (
    filterLicenseSelected.queryKey !== '' &&
    filterLicenseSelected.queryKey !== 'default'
  ) {
    query += `&filter[where][brokerlicense][in]=${filterLicenseSelected.queryKey}`;
  }

  // add query filter with subagent if any subagent has been selected
  if (filterSubagentSelected.queryKey !== '') {
    query += `&filter[where][agencyId][in]=${filterSubagentSelected.queryKey}`;
  }

  // If the user don't select any broker license, always fetch the quotations created by the current user only when user type is AGE
  if (
    (filterLicenseSelected.queryKey === '' ||
      filterLicenseSelected.queryKey === 'default') &&
    loggedUserRole === 'AGE'
  ) {
    query += `&filter[where][createdBy][in]=${currentUser}`;
  }

  // add to query string the filter created By only when user type is ASE because user type AGE always sends the filter
  if (isCheckedCurrentUserFilter && loggedUserRole === 'ASE') {
    query += `&filter[where][createdBy][in]=${currentUser}`;
  }

  return query;
};

export default buildQueryFilterQuotationsMeasurements;
